<!--
 * @Author: lixiaodi
 * @Date: 2020-03-12 16:56:30
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-12-02 15:36:54
 -->
 <template>
    <div class="education-search">
        <!-- 查询 -->
        <div class="search-box">
            <!-- 查询输入框 -->
            <div class="search-input">
              <!-- 关键词输入框 -->
                <el-autocomplete style="width: 100%;"
                    class="inline-input"
                    v-model="condition"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入名称关键词搜索"
                    @select="handleSelect"
                ></el-autocomplete>
            </div>
            <div class="search-btn">
                <el-button @click="search('')">搜索</el-button>
            </div>
        </div>
        <!-- 查询条件提示 -->
<!--        <ul class="condition-ul">
            <li class="condition-li" v-for="(item,index) of conditionList" :key="index" @click="search(item)">{{item}}</li>
        </ul>-->
    </div>
</template>

<script>
import { jump, getUser, removeUser} from "@/untils/auth";
export default {
  name: 'EducationSearch',
  props: ['content'],
  data() {
      return {
        type: this.content.title,
        condition: '',
        options: [],
        value: '',
        conditionList: [],
        pageType: 6,
        restaurants: [
          { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
        ]
      }
  },
  created() {
      this.hotRes();
  },
  mounted() {
      if(getUser()){
          this.onHistoryData()
      }else{
          this.restaurants = []
      }
  },
  methods:{
    querySearch(queryString, cb) {
    //   console.log(this.conditionList)
      let programList = [];
      for(let i=0;i<this.conditionList.length;i++){
        programList.push({'value':this.conditionList[i]})
      }
      let results = queryString ? programList.filter(this.createFilter(queryString)) : programList;
      //基本思路就是实现一个过滤器，过滤存在你输入字段的所有数据。
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());

      /*
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);*/
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString) > -1);
      };
       /* return (restaurant) => {
            return (restaurant.VSearchCoulmn.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };*/
    },
    handleSelect(item) {
        // console.log(item);
      this.search(item)
    },
    // 请求历史记录
    onHistoryData(){
        this.axios.post(window.IPConfig.IP + '/tBSearchHistory/queryPage.do',
            {
                "VSystemId": this.$store.state.user.VSystemId,
                "current": 1,
                "size": 20
            }
        ).then((response) => {
                if (response.data.status == 200) {
                    this.restaurants = response.data.obj.records
                    // console.log(this.restaurants,'得到历史数据------')
                }else{
                    this.restaurants = []
                }
        })
    },

    // 热门搜索关键词
    hotRes (){
      this.axios.post(window.IPConfig.IP + "/tBHotSearch/qureyHotSearch.do", {}).then((res) => {
        if (res.data.status == 200) {
          this.conditionList = res.data.obj
        }
      });
    },
    // 查询跳转新页面
    search(val) {
    //   console.log(" type="+this.type)
        // if(val){
        //     this.condition = val
        // }
        if (this.type == "文档") {
            // this.pageType = 4;
            this.Jump('/education/fileList');
        }else if(this.type == '课件') {
            this.pageType = 3;
            this.Jump('/education/coursewareList')
        }else if(this.type == '师资资源') {
            this.pageType = 4;
            this.Jump('/education/teacherList')
        }

    },
    // 页面跳转
    Jump (path){
        this.$router.push({
            path: path,
            query: {
                pageType: this.pageType,
                condition: this.condition
            }
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.education-search{
    margin .2rem 0rem
}
.search-box{
    border 1px solid #228457
    display flex
    flex-flow row nowrap
    align-items center
}
.search-input{
    display flex
    flex-flow row nowrap
    width 100%
    align-items center
}
.search-input /deep/ .el-input__inner{
    border none
}
.line{
    height .2rem
    width 2px
    background: #efefef
}
.el-button{
    border none
    border-radius 0
    background #228457
    color #ffffff
    line-height 1.2
}
/* 查询条件 */
.condition-ul{
    display: flex;
    padding: .1rem;
    color: #aaa;
}
.condition-li{
    margin-right .1rem
    cursor pointer
}
</style>



// WEBPACK FOOTER //
// src/components/Education/commonView/educationSearch.vue